(function (angular, _) {
    const  MyHippoFormlyDirectives = angular.module('MyHippoFormly.Directives');
    MyHippoFormlyDirectives.directive('mhPolicyDetailUpdatePhone', mhProducerDetailSubOrg);
    mhProducerDetailSubOrg.$inject = ['toaster', 'APIService'];
    function mhProducerDetailSubOrg (toaster, APIService) {
        return {
            restrict: 'E',
            templateUrl: 'common/formly-directives/policy-update-phone-number/template.html',
            wrapper: [],
            overwriteOk: true,
            controller: function ($scope) {
                $scope.errorMessage = '';
                $scope.isEditMode = false;
                $scope.isUpdating = false;

                $scope.$watch('[isEditMode, isUpdating]', () => {
                    $scope.isDisabled = !$scope.isEditMode || $scope.isUpdating;
                });

                $scope.phoneNumber = _.get($scope.model, 'personal_information.phone_number');
                let lastSavedNumber = $scope.phoneNumber;

                $scope.cancel = () => {
                    $scope.phoneNumber = lastSavedNumber;
                    $scope.errorMessage = '';
                    $scope.toggleEditMode();
                };

                $scope.save = () => {
                    if (!$scope.phoneNumber) {
                        $scope.errorMessage = 'Invalid Phone Number';
                    } else {
                        const policyId = $scope.model.id;
                        APIService.updatePersonalInformation(policyId, { phone_number: $scope.phoneNumber }).then(() => {
                            toaster.pop('success', 'Successfully saved phone number');
                            lastSavedNumber = $scope.phoneNumber;
                            $scope.errorMessage = '';
                            $scope.toggleEditMode();
                        }).catch(err => {
                            toaster.pop('error', 'Unable to save phone number');
                        });
                    }
                };

                $scope.toggleEditMode = () => {
                    $scope.isEditMode = !$scope.isEditMode;
                };
            }
        };
    }
})(window.angular, window._);
